import { useContext } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import TEXTS from '../controller/TextVariables';
import { staticYearList } from '../model/StaticVariables';
import DropDown from './Dropdown';

const YearSelect = (props) => {
    const { setSelectedYear, year } = useContext(InterfaceContext);

    const onChangeYearSelect = (val) => {
        setSelectedYear(val);
    };
    const { label, tooltip } = TEXTS.controls.data_year;
    return (
        <div id="year-select" className="year field">
            <DropDown selected={year} label={label} tooltip={tooltip} tooltipPlace={'left'} list={staticYearList} onChange={onChangeYearSelect} />
        </div>
    );
};
export default YearSelect;
